import "core-js/modules/es.array.map";
import React, { Children } from "react";
import PropTypes from "prop-types";
import styles from "./main-navigation-slide-container.css";

function SlideContainer(_ref) {
  var index = _ref.index,
      children = _ref.children;
  return React.createElement("div", {
    className: styles.slideContainer,
    style: {
      transform: "translateX(".concat(index * 100 * -1, "%)")
    }
  }, Children.map(children, function (child) {
    return React.createElement("div", {
      className: styles.slide
    }, child);
  }));
}

SlideContainer.propTypes = {
  index: PropTypes.number,
  children: PropTypes.node
};
export default SlideContainer;